





































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import ProductMaterialForm from '@/components/products/material-form.vue';
const uuidv4 = require('uuid/v4');

@Component({
  components: { PermissionAuth, ProductMaterialForm },
})
export default class ProductMaterial extends BaseComponent {
  @Prop()
  public data: any[];
  @Prop({
    default: false,
  })
  public isEdit: boolean;
  
  @Prop({
    default: false,
  })
  public disabled: boolean;

  @Prop({default:true})
  public showQtdeReferencia: boolean

  public materialFormIsEdit: boolean = false;
  public materialFormOpen: boolean = false;
  public materialFormItem: any = {};

  public subgroups: any[] = [];
  public measurementUnits: any = [];

  private getHeaders() {
    let headers = [];
    headers.push({ text: 'Ativo', value: 'descricao' });
    headers.push({ text: 'Quantidade', value: 'quantidade' });
    if (this.showQtdeReferencia) {
      headers.push({ text: 'Quantidade de referência', value: 'quantidadeReferencia' });
    }
    headers.push({ text: 'Ações', value: 'actions', sortable: false });
    return headers;
  }

  public materialFormOpenHandler(): void {
    this.materialFormIsEdit = false;
    this.materialFormItem = {
      quantidadeReferencia: 1,
    };
    this.materialFormOpen = true;
  }

  public materialFormClose(): void {
    this.materialFormIsEdit = false;
    this.materialFormItem = {};
    this.materialFormOpen = false;
  }

  public materialFormSave(material: any): void {    
    if (!this.materialFormIsEdit) {
      // New Item
      const indexSame = this.data.findIndex((i) => i.idInsumo === material.idInsumo);
      if (indexSame != -1) {
        this.$set(this.data, indexSame, material);
      } else {
        this.data.push(material);
      }
    } else {
      // Edit Item
      const index = this.data.findIndex((i) => i.key === material.key);
      this.$set(this.data, index, material);
    }

    this.materialFormClose();
  }

  public materialEdit(item: any): void {
    item.key = uuidv4()
    this.materialFormIsEdit = true;
    this.materialFormItem = item;
    this.materialFormOpen = true;
  }

  public materialDelete(item: any): void {
    const index = this.data.findIndex((i) => i.idInsumo === item.idInsumo);
    this.data.splice(index, 1);
  }
}
